import { queryClient } from "~/plugins/vue-query";
import { journalService } from "~/utils/api/journalService";
import { getProjectId } from "~/utils/getProjectId";

export default defineNuxtRouteMiddleware(async () => {
  const projectId = getProjectId();

  if (projectId) {
    queryClient.fetchQuery({
      queryKey: ["journals"],
      queryFn: () =>
        journalService.getJournals({
          client_project_id: projectId,
          with: ["author"],
        }),
    });
  }
});
